<template>
  <v-dialog :value="showDialog" max-width="600" persistent @keydown.esc="$emit('close')">
    <v-card class="pa-4">
      <div class="d-flex align-center justify-space-between mb-4">
        <h2 class="mb-0">Adicionar Criticidade</h2>
        <v-btn icon small @click="$emit('close')" color="#707070">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-row class="ma-0" dense>
        <v-col cols="12">
          <label class="label">Unidade</label>
          <v-autocomplete
            v-model="form.unidadeId"
            :items="unidades"
            outlined
            hide-details="auto"
            class="primary-input"
            item-text="name"
            item-value="id"
            append-icon=""
            :error="fieldErrors.unidadeId && !form.unidadeId"
            :error-messages="fieldErrors.unidadeId && !form.unidadeId ? ['Campo obrigatório'] : []"
            @change="$emit('unidade-change')"
          ></v-autocomplete>
        </v-col>

        <v-col cols="12">
          <label class="label">Setor</label>
          <v-autocomplete
            v-model="form.departmentId"
            :items="dialogDepartments"
            outlined
            hide-details="auto"
            class="primary-input"
            item-text="name"
            item-value="id"
            append-icon=""
            :disabled="!form.unidadeId"
            :error="fieldErrors.departmentId && !form.departmentId"
            :error-messages="fieldErrors.departmentId && !form.departmentId ? ['Campo obrigatório'] : []"
            @change="form.subDepartmentId = null"
          ></v-autocomplete>
        </v-col>

        <v-col cols="12">
          <label class="label">Sub-setor (opcional)</label>
          <v-autocomplete
            v-model="form.subDepartmentId"
            :items="dialogSubDepartments"
            outlined
            hide-details="auto"
            class="primary-input"
            item-text="name"
            item-value="id"
            clearable
            append-icon=""
            :disabled="!dialogSubDepartments.length"
          ></v-autocomplete>
        </v-col>

        <v-col cols="12">
          <label class="label">Oficina</label>
          <v-autocomplete
            v-model="form.workshopId"
            :items="dialogWorkshops"
            outlined
            hide-details="auto"
            class="primary-input"
            item-text="name"
            item-value="id"
            append-icon=""
            :disabled="!form.unidadeId"
            :error="fieldErrors.workshopId && !form.workshopId"
            :error-messages="fieldErrors.workshopId && !form.workshopId ? ['Campo obrigatório'] : []"
          ></v-autocomplete>
        </v-col>

        <v-col cols="12">
          <label class="label">Criticidade</label>
          <v-autocomplete
            v-model.number="form.urgencyLevel"
            :items="urgencyLevels"
            outlined
            hide-details="auto"
            class="primary-input"
            item-text="label"
            item-value="value"
            append-icon=""
            :error="fieldErrors.urgencyLevel && ![0, 1, 2].includes(form.urgencyLevel)"
            :error-messages="fieldErrors.urgencyLevel && ![0, 1, 2].includes(form.urgencyLevel) ? ['Campo obrigatório'] : []"
          ></v-autocomplete>
        </v-col>
      </v-row>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
          dark
          depressed
          @click="$emit('close')"
          class="quaternary-button ma-1"
          color="#FF4F64"
        >
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn class="secondary-button" depressed :loading="saveLoading" @click="$emit('save')">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CreateCriticalityDialog',
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    fieldErrors: {
      type: Object,
      default: () => ({}),
    },
    unidades: {
      type: Array,
      default: () => [],
    },
    dialogDepartments: {
      type: Array,
      default: () => [],
    },
    dialogSubDepartments: {
      type: Array,
      default: () => [],
    },
    dialogWorkshops: {
      type: Array,
      default: () => [],
    },
    urgencyLevels: {
      type: Array,
      default: () => [],
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
